import { render, staticRenderFns } from "./M22_S5.vue?vue&type=template&id=322ffba4&scoped=true"
import script from "./M22_S5.vue?vue&type=script&lang=js"
export * from "./M22_S5.vue?vue&type=script&lang=js"
import style0 from "./M22_S5.vue?vue&type=style&index=0&id=322ffba4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322ffba4",
  null
  
)

export default component.exports